// Cookie settings event helper. Privacy Policy / Terms of Use are now static
// pages (public/privacy.html, public/terms.html) linked to directly rather
// than rendered as in-app modals. The cookie banner is still reopened via a
// window event so any surface (footer) can trigger it without prop-drilling.

export const COOKIE_SETTINGS_EVENT = 'fiwara:cookieSettings';

// Re-open the cookie consent banner so the user can change/withdraw consent.
export const openCookieSettings = () => {
  window.dispatchEvent(new Event(COOKIE_SETTINGS_EVENT));
};
